import { Button } from "antd";
import { getEllipsisTxt } from "helpers/formatters";
import React, { useState } from "react";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import { useMoralis, useMoralisQuery } from "react-moralis";

import ConnectWallet from "./ConnectWallet";

function NFTComponent(props) {
  const [notEligible, setNotEligible] = useState(false);
  const [claimed, setClaimed] = useState(false);
  const [id, setId] = useState(1);
  const [showWallet, setShowWallet] = useState(false);
  const { isAuthenticated, authenticate, Moralis } = useMoralis();
  const { marketAddressPass, contractABIPass, walletAddress } =
    useMoralisDapp();
  const contractABIJson = JSON.parse(contractABIPass);
  const claimFunction = "noOfAirdroppedNFT";
  const claimNFTFunction = "claim";

  const nft = props.nft;
  const nftId = props.index;

  async function claim(id) {
    if (!isAuthenticated) {
      setShowWallet(true);
    } else {
      const ops = {
        contractAddress: marketAddressPass,
        functionName: claimFunction,
        abi: contractABIJson,
        params: {
          account: walletAddress,
          tokenId: id,
        },
      };

      try {
        const res = await Moralis.executeFunction(ops);
        console.log("result", res);
        if (res[0] === false && res[2] === "0") {
          setNotEligible(true);
          setId(id);
        } else if (res[0] === true && res[2] === "1") {
          setClaimed(true);
          // setId(id);
        } else {
          claimNft(id);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  async function claimNft(id) {
    alert(id);
    const ops = {
      contractAddress: marketAddressPass,
      functionName: claimNFTFunction,
      abi: contractABIJson,
      params: {
        account: walletAddress,
        tokenId: id,
      },
    };

    try {
      const res = await Moralis.executeFunction(ops);
      console.log("result", res);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
      {showWallet && <ConnectWallet />}
      <div className="pass-box img-box h-100 m-auto">
        <img
          src={nft.image}
          alt="Content Contributor Pass"
          className="m-auto py-5 px-3"
        ></img>
        <div className="pass-padding mb-4">
          <h2 className="pass-title">{nft.name}</h2>
          <span className="pass-subtitle">
            airdropped on 30/08/2022 at 10.00 am IST
          </span>
          <p className="pass-desc my-3">{nft.description}</p>
          <span className="pass-nft">
            {nft.remainingCopies} / {nft.copies} remaining
          </span>
          <h5 className="text-white my-5">
            {isAuthenticated &&
              "Your Wallet Address: " + getEllipsisTxt(walletAddress, 6)}
          </h5>
          <Button
            className="primary-button text-white claim-button pass-desc mb-3"
            onClick={() => claim(nftId)}
            size="large"
          >
            CLAIM
          </Button>
          {notEligible === true && (
            <p className="text-danger">You are not eligible to claim</p>
          )}
          {claimed === true && (
            <p className="text-danger">You already claimed this NFT</p>
          )}
        </div>
      </div>
    </div>
  );
}
export default NFTComponent;
